/**
 * This file is auto-generated. Run yarn workspace @atlassiansox/project-pages generate:feature-flags to re-generate.
 */
import { fg } from '@atlaskit/platform-feature-flags';
export interface FeatureFlags {
	'platform.google-drive-in-project-pages': boolean;
	'platform-component-visual-refresh': boolean;
	'confluence-issue-terminology-refresh': boolean;
	'confluence_live_pages_enabled_in_jira': boolean;
	'project-pages-zoom-accessibility': boolean;
	'project_pages_delete_corrupt_relationships': boolean;
}
export const getGeneratedBooleanFeatureFlags = (): FeatureFlags | object => {
	try {
		const flags = {
			'platform.google-drive-in-project-pages': fg('platform.google-drive-in-project-pages'),
			'platform-component-visual-refresh': fg('platform-component-visual-refresh'),
			'confluence-issue-terminology-refresh': fg('confluence-issue-terminology-refresh'),
			'confluence_live_pages_enabled_in_jira': fg('confluence_live_pages_enabled_in_jira'),
			'project-pages-zoom-accessibility': fg('project-pages-zoom-accessibility'),
			'project_pages_delete_corrupt_relationships': fg('project_pages_delete_corrupt_relationships'),
		};
		return flags;
	} catch (error) {
		return {};
	}
};
export const generatedBooleanFeatureFlagKeys = ['platform.google-drive-in-project-pages', 'platform-component-visual-refresh', 'confluence-issue-terminology-refresh', 'confluence_live_pages_enabled_in_jira', 'project-pages-zoom-accessibility', 'project_pages_delete_corrupt_relationships'];
